<ion-content fullscreen>
  <div id="wrapper" class="ion-padding">
    <div class="header-logo-container">
      <ion-icon src="/assets/icon/tecservice.svg" class="header-logo"></ion-icon>
    </div>

    <div id="card">
      <ion-grid>
        <ion-row>
          <ion-col class="icons">
            <ion-icon name="log-out-outline" (click)="logout()" color="light"></ion-icon>
            &nbsp;
            <ion-icon
              name="settings"
              (click)="goSettings()"
              color="light"
              [hidden]="user?.type2==='business'||user?.type2==='expresotec'||user?.type2==='transportec-driver'"
            ></ion-icon>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col col-3>
            <img [src]="user.avatar" *ngIf="user && user.avatar" (click)="viewImage(user.avatar)" />
            <img src="/assets/imgs/logo-azul.png" *ngIf="!user || !user.avatar" />

            <p class="utype" hidden>{{user?.type}}</p>
          </ion-col>
          <ion-col col-9>
            <h4>{{user?.name}} {{user?.lastname}}</h4>
            <h5 hidden>
              Matrícula:
              <span></span>
            </h5>
            <p>{{user?.email}}</p>
            <p>Campus: {{user?.campus_actual?.name}}</p>
            <p class="member" *ngIf="user?.scholarship">Beca de: {{user?.scholarship}}%</p>
            <p class="member">Periodo: {{period}}</p>
          </ion-col>
        </ion-row>
        <ion-row>
          <ion-col>&nbsp;</ion-col>
        </ion-row>
      </ion-grid>
      <div id="period">{{user?.user_type?.name || user?.type}}</div>
    </div>
    <div class="scrollY">
      <ion-list>
        <ion-item button (click)="goTerms()" lines="none">
          <ion-icon slot="end" class="icono" src="assets/icon/terms.svg"></ion-icon>
          Términos y condiciones
        </ion-item>
        <ion-item button (click)="goPrivacy()" lines="none">
          <ion-icon slot="end" class="icono" src="assets/icon/privacy.svg"></ion-icon>
          Aviso de privacidad
        </ion-item>
        <ion-item button (click)="presentActionSheet()" lines="none">
          <ion-icon slot="end" class="icono" src="assets/icon/help.svg"></ion-icon>
          Tutoriales
        </ion-item>
        <ion-item button (click)="help()" lines="none">
          <ion-icon slot="end" class="icono" src="assets/icon/help.svg"></ion-icon>
          Soporte
        </ion-item>
        <ion-item button (click)="presentOtherActionSheet()" lines="none">
          <ion-icon slot="end" class="icono" src="assets/icon/elisa-icon.svg"></ion-icon>
          Otros
        </ion-item>
        <ion-item
          button
          [routerLink]="['billing']"
          lines="none"
          [hidden]="user?.type2==='business'||user?.type2==='expresotec'||user?.type2==='transportec-driver'"
        >
          <ion-icon slot="end" class="icono" name="document-text-outline"></ion-icon>
          Facturación
        </ion-item>
        <ion-item
          button
          (click)="showCampusPicker()"
          [hidden]="user?.type2==='business'||user?.type2==='expresotec'||user?.type2==='transportec-driver'"
          lines="none"
        >
          <ion-icon slot="end" class="icono" src="assets/icon/campus-switch.svg"></ion-icon>
          Cambiar Campus
        </ion-item>
      </ion-list>
      <p>&nbsp;</p>
      <div id="version">{{version}}.</div>
    </div>
  </div>
</ion-content>
